import { api } from '../../helpers/Api';
import { Customer } from '../Customers/Model';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('destinations/' + id).then(function (customer) { return new Customer(customer); });
        return api.get('destinations?order=name');
    };
    default_1.prototype.readCountries = function (param, queries) {
        if (param) {
            if (typeof param === 'number') {
                return api.get('destinations/countries' + param);
            }
            else {
                return api.get('destinations/countries');
            }
        }
        // genero querystring
        if (queries) {
            var queryString = generateQuerystring(queries);
            return api.get('destinations/countries' + queryString);
        }
        return api.get('destinations/countries');
    };
    default_1.prototype.readStates = function (params, queries) {
        if (queries) {
            var queryString = generateQuerystring(queries);
            return api.get('destinations/states' + queryString);
        }
        return api.get('destinations/states');
    };
    default_1.prototype.addMultiple = function (value) {
        return api.post('destinations/multiple', value);
    };
    default_1.prototype.addCities = function (value) {
        return api.post('destinations/cities', value);
    };
    default_1.prototype.deleteCity = function (value) {
        return api.delete('destinations/cities/' + value.id);
    };
    default_1.prototype.create = function (data) {
        return api.post('destinations', data);
    };
    default_1.prototype.update = function (id, data) {
        return api.put('destinations/' + id, data);
    };
    default_1.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    default_1.prototype.disable = function (id, disabled) {
        throw new Error('Method not implemented.');
    };
    return default_1;
}());
export default default_1;
var generateQuerystring = function (queries) {
    console.log('queries: ', queries);
    var queryArray = [];
    for (var key in queries) {
        if (queries.hasOwnProperty(key)) {
            if (queries[key] === true) {
                queryArray.push("".concat(key, "=true"));
            }
            if (key === 'country' || key === 'country_id') {
                queryArray.push("".concat(key, "=").concat(queries[key]));
            }
        }
    }
    // uno con '&' y '?' al principio si hay elementos
    var queryString = queryArray.length > 0 ? '?' + queryArray.join('&') : '';
    return queryString;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Destinations/DestinationsStore.ts
// module id = 751
// module chunks = 0